import getYoutube from "./getYoutube";

export default {
  getYoutube,
}